import {Link} from "react-router-dom";

//CSS
import styles from "./allExcursions.module.less";

export default function AllExcursions ({excursions,language, zone}) {

  let listExcursions="No hay excursiones"

  if(Array.isArray(excursions) && excursions.length > 0){
    listExcursions = excursions.map((excursion,index)=>{
      return (
        <div key={index} className={styles.excursion} data-excursionid={excursion.id}>
          <Link to={'/' + language + '/excursion/'  + zone + '/' + excursion.webslug}>
            <div className={styles.title}>{excursion.webtitle}</div>
            <div className={styles.subtitle}>{excursion.websubtitle}</div>
          </Link>
        </div>
      );
    });
  }

  return (
    <div className={styles.allexcursions}>
      {listExcursions}
    </div>
  );

}